import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;

// ── Kalkulasi instan PLN (tanpa simpan) ──────────────────────────────────────
export async function calculateElectricityPreview(body) {
  return await instance({ baseURL }).post("/utility-reading/calculate", body);
}

// ── Kalkulasi instan Air (tanpa simpan) ──────────────────────────────────────
export async function calculateWaterPreview(body) {
  return await instance({ baseURL }).post(
    "/utility-reading/calculate-water",
    body,
  );
}

// ── Utility Readings ──────────────────────────────────────────────────────────
export async function getUtilityReadings(queryParams = "") {
  return await instance({ baseURL }).get(
    "/utility-reading/reading" + queryParams,
  );
}

export async function getUtilityReadingById(id, utilityType) {
  return await instance({ baseURL }).get(
    `/utility-reading/reading/${id}?utility_type=${utilityType}`,
  );
}

export async function inputUtilityReading(body) {
  return await instance({ baseURL }).post("/utility-reading/reading", body);
}

export async function inputUtilityReadingBatch(body) {
  return await instance({ baseURL }).post(
    "/utility-reading/reading/batch",
    body,
  );
}

// ── Invoice ───────────────────────────────────────────────────────────────────
export async function previewUtilityInvoice(queryParams = "") {
  return await instance({ baseURL }).get(
    "/utility-reading/preview" + queryParams,
  );
}

export async function generateUtilityInvoice(body) {
  return await instance({ baseURL }).post("/utility-reading/generate", body);
}

// ── Verifikasi Reading ────────────────────────────────────────────────────────
export async function verifyUtilityReading(id, body) {
  return await instance({ baseURL }).patch(
    `/utility-reading/reading/${id}/verify`,
    body,
  );
}
